import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import FinanceLeftPanel from "../include/FinanceLeftPanel";
import Global from "../../APIConfig";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import AuthUser from "../../AuthUser";
import ListLoader from "../Loaders/ListLoader";


function StockDetails() {
    let navigate = useNavigate();
    const { UniqueId } = useParams();
    const location = useLocation();
    const { headers1, headers2, logout } = AuthUser();
    const [Loading, setLoading] = useState(true);
    const [stockin, setStockin] = useState(0);
    const [stockout, setStockout] = useState(0);
    const [stocklist, setStocklist] = useState([]);
    const [searchvalue, setSearchvalue] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1); // Total number of pages
    const [nextPageUrl, setNextPageUrl] = useState(null);
    const [prevPageUrl, setPrevPageUrl] = useState(null);
    const pageRangeDisplayed = 2;
    const [showpage, setShowpage] = useState('InStock');
    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const page = query.get('page') ? parseInt(query.get('page'), 10) : 1;
        const search = query.get('search') || '';
        setCurrentPage(page);
        setSearchvalue(search);
        getStockDetailByUniqueId(page, showpage);
    }, []);

    const getStockDetailByUniqueId = (page = 1, showpage) => {
        setLoading(true);
        axios({
            method: 'post',
            url: Global.baseUrl + 'getStockDetailByUniqueId',
            headers: headers1,
            data: {
                UniqueId: UniqueId,
                pagetype: showpage,
                page: page
            }
        })
            .then(function (response) {
                console.log("response.data", response.data);
                if (response.data.status == 200) {
                    var data = response.data;
                    setStockin(data.stockin);
                    setStockout(data.stockout);
                    setStocklist(data.stocklist.data);
                }
                else{
                    // toast.error(response.data.message);
                    setStockin(response.data.stockin);
                    setStockout(response.data.stockout);
                    setStocklist([]);
                }
                setLoading(false);
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
                setLoading(false);
            });
    }

    // Update the URL and fetch the data for the selected page
    const handlePageChange = (pageNumber) => {
        const query = new URLSearchParams(location.search);
        query.set('page', pageNumber);
        navigate(`?${query.toString()}`);
    };
    const handleSearchChange = (event) => {
        setSearchvalue(event.target.value);
    };
    const handleSearchSubmit = (event) => {
        event.preventDefault();
        const query = new URLSearchParams(location.search);
        query.set('search', searchvalue);
        query.set('page', 1); // Reset to page 1 on a new search
        navigate(`?${query.toString()}`);
    };
    // Handle Previous button click
    const handlePreviousPage = () => {
        if (prevPageUrl) {
            handlePageChange(currentPage - 1);
        }
    };

    // Handle Next button click
    const handleNextPage = () => {
        if (nextPageUrl) {
            handlePageChange(currentPage + 1);
        }
    };

    // Create pagination items for each page, showing a limited number of page numbers with ellipses
    const renderPageNumbers = () => {
        const pages = [];

        // Always show the first page
        if (currentPage > pageRangeDisplayed + 1) {
            pages.push(
                <li key={1} className="page-item">
                    <button className="page-link" onClick={() => handlePageChange(1)}>1</button>
                </li>
            );
            pages.push(<li key="start-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
        }

        // Show the range of pages around the current page
        for (let i = Math.max(1, currentPage - pageRangeDisplayed); i <= Math.min(lastPage, currentPage + pageRangeDisplayed); i++) {
            pages.push(
                <li key={i} className={`page-item ${i === currentPage ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => handlePageChange(i)}>
                        {i}
                    </button>
                </li>
            );
        }

        // Always show the last page
        if (currentPage < lastPage - pageRangeDisplayed) {
            pages.push(<li key="end-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
            pages.push(
                <li key={lastPage} className="page-item">
                    <button className="page-link" onClick={() => handlePageChange(lastPage)}>{lastPage}</button>
                </li>
            );
        }

        return pages;
    };

    return (
        <>
            <FinanceLeftPanel />
            <main className='home-section'>
                <Header />
                <ToastContainer />
                <section className="my-3">
                    <div className="row">
                        <div className="col-12 col-md">
                            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                                <div className="d-block mb-4 mb-md-0">
                                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                            <li className="breadcrumb-item">
                                                <a href="/Admin-Dash">
                                                    <i className="bx bx-home text-primary-400 fs-6"></i>
                                                </a>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">Current Stock Details</li>
                                        </ol>
                                    </nav>
                                    <div className="d-flex justify-content-between">
                                        <div className="">
                                            <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                                                <i className="bx bx-arrow-back "></i>
                                            </button>
                                        </div>
                                        <div className="ps-2 ">
                                            <h2 className="h4">Current Stock Details</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="btn-toolbar mb-2 mb-md-0">
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="mb-3">
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <div className="card border-0 shadow">
                                    <div className="card-body">
                                        <div className="row d-block d-xl-flex align-items-center">
                                            <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                                <div className="icon-shape icon-shape-primary rounded me-4 me-sm-0">
                                                    <i className="bx bx-time"></i>
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-7 px-xl-0">
                                                <div className="d-none d-sm-block">
                                                    <h2 className="h6 text-gray-400 mb-0">In Stock</h2>
                                                    <h3 className="fw-extrabold mb-2"><a href="">{stockin}</a></h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-3">
                                <div className="card border-0 shadow">
                                    <div className="card-body">
                                        <div className="row d-block d-xl-flex align-items-center">
                                            <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                                <div className="icon-shape icon-shape-primary rounded me-4 me-sm-0">
                                                    <i className="bx bx-check-double"></i>
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-7 px-xl-0">
                                                <div className="d-none d-sm-block">
                                                    <h2 className="h6 text-gray-400 mb-0"> Out Stock</h2>
                                                    <h3 className="fw-extrabold mb-2"><a href="">{stockout}</a></h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="row">
                        <div className="row">
                            <div className="col-12 col-md">
                                <div className="custom_nav_data_table">
                                    <ul className="nav nav-tabs">
                                        <li className="nav-item">
                                            <button onClick={() => {setShowpage('InStock'); getStockDetailByUniqueId(currentPage, 'InStock')}} className={showpage == 'InStock' ? "nav-link active" : "nav-link"}>In Stock</button>
                                        </li>
                                        <li className="nav-item">
                                            <button onClick={() => {setShowpage('OutStock'); getStockDetailByUniqueId(currentPage, 'OutStock')}} className={showpage == 'OutStock' ? "nav-link active" : "nav-link"}>Out Stock</button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="data_table">
                        <div className="card card-body border-0 shadow table-wrapper table-responsive ">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th className="border-gray-200">AWB#</th>
                                        <th className="border-gray-200">Booking Type</th>
                                        <th className="border-gray-200">Type</th>
                                    </tr>
                                </thead>
                                {Loading ?
                                    <tbody>
                                        <tr><td colSpan={6}><ListLoader/></td></tr>
                                    </tbody>
                                :
                                <tbody>
                                {stocklist.length > 0 ?
                                    <>
                                        {stocklist.map((stock, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        {stock.slip_no}<br />
                                                        <small>{stock.entrydate}</small>
                                                    </td>
                                                    <td>
                                                        <span className="fw-normal text-capitalize">{stock.shipment_type}</span>
                                                    </td>
                                                    <td>
                                                        <span className="fw-normal"><span className="badge bg-primary">{stock.nrd}</span></span><br />
                                                        {stock.booking_mode == 'Prepaid' ?
                                                            <span className="fw-normal"><span className="badge bg-danger">Prepaid</span></span>
                                                            :
                                                            <span className="fw-normal"><span className="badge bg-primary">COD</span></span>
                                                        }

                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </>
                                    :
                                        <tr className="text-center text-danger"><td colSpan={6}>Record Not Found</td></tr>
                                    }
                                    </tbody>
                                }
                            </table>

                        </div>
                    </section>
                </section>
                <Footer />
            </main>
        </>

    );
}
export default StockDetails;